import React, { useEffect } from 'react';
import './WoolPops.scss';
import registerAnimations from './registerAnimations';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget'

import quote from '../../static/images/woolpops/quote.png'
import upsell from '../../static/images/woolpops/upsell.png'

import staticImageSec4DarkPink from "../../static/images/woolpops/Dark-Pink.png"
import staticImageSec4DarkOrange from "../../static/images/woolpops/Dark-Orange.png"
import staticImageSec4DarkRed from "../../static/images/woolpops/Dark-Red.png"
import staticImageSec4DarkYellow from "../../static/images/woolpops/Dark-Yellow.png"
import staticImageSec4DarkGreen from "../../static/images/woolpops/Dark-Green.png"
import staticImageSec4DarkBlue from "../../static/images/woolpops/Dark-Blue.png"
import staticImageSec4LightPink from "../../static/images/woolpops/Light-Pink.png"
import staticImageSec4LightOrange from "../../static/images/woolpops/Light-Orange.png"
import staticImageSec4LightRed from "../../static/images/woolpops/Light-Red.png"
import staticImageSec4LightYellow from "../../static/images/woolpops/Light-Yellow.png"
import staticImageSec4LightGreen from "../../static/images/woolpops/Light-Green.png"
import staticImageSec4LightBlue from "../../static/images/woolpops/Light-Blue.png"
import staticGlowEffect1 from '../../static/images/woolpops/glow-effect-1.png'
import staticGlowEffect2 from '../../static/images/woolpops/glow-effect-2.png'
import staticGlowEffect3 from '../../static/images/woolpops/glow-effect-3.png'
import staticGlowEffect4 from '../../static/images/woolpops/glow-effect-4.png'
import staticLightFabric from '../../static/images/woolpops/light-fabric.png'
import staticDarkFabric from '../../static/images/woolpops/dark-fabric.png'
import staticCircleSemi1 from '../../static/images/woolpops/circle-semi-1.png'
import staticCircleSemi2 from '../../static/images/woolpops/circle-semi-2.png'
import staticSec3MobileImage from '../../static/images/woolpops/sec3-bg-sm.jpg'
import staticSec3Image from '../../static/images/woolpops/sec3-bg.jpg'
import staticSec5MobileImage from '../../static/images/woolpops/sec5-bg-sm.jpg'
import staticSec5Image from '../../static/images/woolpops/sec5-bg.jpg'

import staticZeroWaste from '../../static/images/woolpops/icon-zero-waste-policy.svg'
import staticSustainable from '../../static/images/woolpops/icon-sustainable.svg'
import staticRecycled from '../../static/images/woolpops/icon-recycled.svg'

import staticShoeLayer1 from '../../static/images/woolpops/shoe-layer-1.png'
import staticShoeLayer2 from '../../static/images/woolpops/shoe-layer-2.png'
import staticShoeLayer1Effect from '../../static/images/woolpops/shoe-layer-1-effect.png'
import staticShoeLayer2Effect from '../../static/images/woolpops/shoe-layer-2-effect.png'

const LandingPageWoolPops = ({
  // Section 1 - Header
  sec1Button1Text,
  sec1Button1Url,
  sec1Heading,
  sec1Content,
  sec1Price,

  // Section 2
  sec2Button1Text,
  sec2Button1Url,
  sec2Heading,
  sec2Content,

  // Section 3
  sec3Heading,
  sec3Content,
  sec3Button1Text,
  sec3Button1Url,
  sec3MobileImage,
  sec3Image,

  // Section 4 - Carouse
  sec4Heading,
  imageSec4DarkPink,
  imageSec4DarkOrange,
  imageSec4DarkRed,
  imageSec4DarkYellow,
  imageSec4DarkGreen,
  imageSec4DarkBlue,
  imageSec4LightPink,
  imageSec4LightOrange,
  imageSec4LightRed,
  imageSec4LightYellow,
  imageSec4LightGreen,
  imageSec4LightBlue,
  glowEffect1,
  glowEffect2,
  glowEffect3,
  glowEffect4,
  lightFabric,
  darkFabric,
  circleSemi1,
  circleSemi2,

  // Section 5
  sec5Heading,
  sec5Content,
  sec5Button1Text,
  sec5Button1Url,
  sec5Usp1Content,
  sec5Usp2Content,
  sec5Usp3Content,
  zeroWaste,
  sustainable,
  recycled,
  sec5MobileImage,
  sec5Image,

  // Section 6
  sec6Heading,
  sec6Content,
  shoeLayer1,
  shoeLayer2,
  shoeLayer1Effect,
  shoeLayer2Effect,

  // Section 7
  sec7Content,
  sec7Button1Text,
  sec7Button1Url,
  sec7Button2Text,
  sec7Button2Url,
}) => {
  useEffect(() => {
    registerAnimations()

    if (window) {
      const { $ } = window;

      $(document).ready(function(){
        $('.slick-slider-woolpops').not('.slick-initialized').slick({
          dots: false,
          arrows: false,
          infinite: false,
          centerMode: true,
          centerPadding: '60px',
          autoplay: true,
          autoplaySpeed: 15000,
          slidesToShow:3,
          initialSlide: 2,
          responsive: [
            {
              breakpoint: 1439,
              settings: {
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: true, 
                centerPadding: '60px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
              }
            }
          ]
        });
    
        $('#slick-next').on('click', function(){
          $('.slick-slider-woolpops').slick('next');
        });
        $('#slick-prev').on('click', function(){
          $('.slick-slider-woolpops').slick('prev');
        });
    
        $(document).on('click', '.shoes-var-nav ul li a', function(e){
          e.preventDefault();
          $('.shoes-var-nav ul li').removeClass('active');
          $(this).closest('li').addClass('active');
          if($('.slick-slider-woolpops .slick-center').length){
              $('.slick-slider-woolpops figure').removeClass('switch-shoes'); 
              $('.slick-slider-woolpops .slick-center').toggleClass('switch-shoes');
          }
        });
      });
    }
  }, [])

  return (
    <div className="landingpage-woolpops">

      {/* Section 1 heading */}
      <section className="banner text-md-right">
        <div className="container">
          <div className="row">
            <article className="content clearfix text-md-left col-12  col-md-7 col-xl-6 ml-auto">
              {sec1Heading}
              <p className="quality">{sec1Content}</p>
              <p className="price pt-2 pt-lg-4">{sec1Price}</p>
            </article>
          </div>
        </div>
        <div className="cta text-center text-md-left">
          <div className="container px-0 px-md-3">
            <div className="row btn-cont">
              <div className="col-12 col-md-7 col-xl-6 ml-auto"><a href={sec1Button1Url} className="btn btn-light btn-size-md mb-3">{sec1Button1Text}</a></div>
            </div>
          </div>
        </div>
        <img src={glowEffect1} alt="" className="d-none d-md-block animated fadeInLeft  glow-effect glow-effect-1" />
        <img src={glowEffect2} alt="" className="d-none d-md-block animated fadeInRight glow-effect glow-effect-2" />
      </section>

      {/* Section 2 */}
      <section className="sec sec2 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-9 col-md-7 col-lg-7 col-xl-5 mr-auto  align-self-center">
              {sec2Heading}
              <p className="pr-5 ">{sec2Content}</p>
              <p className="btn-group pt-4 mb-0 text-center">
                <a href={sec2Button1Url} className="btn btn-light mb-1 mr-2 btn-size-md">{sec2Button1Text}</a>
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Section 3 */}
      <style>
        {`
          .sec3 {
            background-image: url(${sec3MobileImage});
          }

          @media (min-width: 768px) {
            .sec3 {
              background-image: url(${sec3Image});
            }
          }
        `}
      </style>
      <section className="sec sec3 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-9 col-md-7 col-lg-7 col-xl-6 mr-auto  align-self-center">
              {sec3Heading}
              <p className="pr-5 ">{sec3Content}</p>
              <p className="btn-group pt-4 mb-0 text-center">
                <a href={sec3Button1Url} className="btn btn-outline-light mb-1 mr-2 btn-size-md">{sec3Button1Text}</a>  
              </p>
            </article>
          </div>
        </div>
      </section> 

      {/* Section 4 */}
      <section className="sec sec4 p-4 p-sm-5 p-lg-5 d-flex">
        <div className="container px-0 flex-grow-1">
          <div className="row flex-grow-1">
            <article className="content col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mr-auto align-self-center align-self-md-center">
              {sec4Heading}
            </article>
          </div>
          <div className="slick-slider-cont">
            <div className="slick-slider-woolpops">
              <div className="slide">
                <figure><img src={imageSec4DarkPink} alt="" /> <img src={imageSec4LightPink} alt="" className="light-color" /></figure>
              </div>
              <div className="slide">
                <figure><img src={imageSec4DarkOrange} alt="" /> <img src={imageSec4LightOrange} alt="" className="light-color" /></figure>
              </div>
              <div className="slide">
                <figure><img src={imageSec4DarkRed} alt="" /> <img src={imageSec4LightRed} alt="" className="light-color" /></figure>
              </div>
              <div className="slide">
                <figure><img src={imageSec4DarkYellow} alt="" /> <img src={imageSec4LightYellow} alt="" className="light-color" /></figure>
              </div>
              <div className="slide">
                <figure><img src={imageSec4DarkGreen} alt="" /> <img src={imageSec4LightGreen} alt="" className="light-color" /></figure>
              </div>
              <div className="slide">
                <figure><img src={imageSec4DarkBlue} alt="" /> <img src={imageSec4LightBlue} alt="" className="light-color" /></figure>
              </div>
            </div>
            <button className="slick-prev slick-arrow" id="slick-prev" aria-label="Previous" type="button">Previous</button>
            <button className="slick-next slick-arrow" id="slick-next" aria-label="Next" type="button">Next</button>
            <figure className="circle-semi circle-semi-2"><img src={circleSemi2} alt="" /></figure>
            <figure className="circle-semi circle-semi-1"> <img src={circleSemi1} alt="" /></figure>
          </div>
          <nav className="shoes-var-nav mt-md-4 mt-xl-5 text-center">
            <ul className="list-inline ">
              <li className="list-inline-item"><a href="#"><img src={lightFabric} alt="" /></a></li>
              <li className="list-inline-item"><a href="#"><img src={darkFabric} alt="" /></a></li>
            </ul>
          </nav>
        </div> 
      </section>

      {/* Section 5 */}
      <style>
        {`
          .sec5 {
            background-image: url(${sec5MobileImage});
          }

          @media (min-width: 768px) {
            .sec5 {
              background-image: url(${sec5Image});
            }
          }
        `}
      </style>
      <section className="sec sec5 d-flex">
        <div className="container d-flex flex-grow-1 position-relative">
          <div className="row  flex-grow-1 position-static">
            <article className="content col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 pl-lg-4 ml-auto align-self-center order-md-2 text-center text-md-left">
              {sec5Heading}
              <p>{sec5Content}</p>
              <p className="text-center text-md-left btn-group pt-3 mb-0 d-md-block ">
                <a href={sec5Button1Url} className="btn btn-outline-light mb-1 btn-size-md">{sec5Button1Text}</a>
              </p>
            </article>
            <article className="icon-list-cont position-static mt-5 mt-md-0 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7 ml-auto align-self-center order-md-1 text-center text-uppercase">
              <img src={glowEffect3} alt="" className="d-none d-md-block glow-effect glow-effect-3 hide animated" /> 
              <div className="icon-list">
                <div className="row compact">
                  <div className="col-4"><figure><img src={zeroWaste} alt="" /></figure>{sec5Usp1Content}</div>
                  <div className="col-4"><figure><img src={sustainable} alt="" /></figure>{sec5Usp2Content}</div>
                  <div className="col-4"><figure><img src={recycled} alt="" /></figure>{sec5Usp3Content}</div>
                </div>
              </div>
              <img src={glowEffect4} alt="" className="glow-effect glow-effect-4 hide animated" />
            </article> 
          </div>
        </div>
      </section> 

      {/* Section 6 */}
      <section className="sec sec6 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-10 col-sm-8 col-md-6 col-lg-6 col-xl-5 mr-auto  align-self-center">
              {sec6Heading}
              <p className="pr-5 ">{sec6Content}</p>
            </article>
            <div className="col-2 col-sm-4 col-md-6 col-lg-6 col-xl-7 mr-auto position-static">
              <figure className="washable-shoe-cont">
                <p className="washable-shoe d-md-inline-block position-relative">
                  <img src={shoeLayer1} className="shoe-layer shoe-layer-1 hide animated" alt="" />
                  <img src={shoeLayer2} className="shoe-layer shoe-layer-2 hide animated delay-1" alt="" />
                  <img src={shoeLayer1Effect} className="shoe-layer-effect shoe-layer-1-effect hide animated delay-2" alt="" />
                  <img src={shoeLayer2Effect} className="shoe-layer-effect shoe-layer-2-effect hide animated delay-3" alt="" />
                </p>
              </figure>
            </div>
          </div>
        </div>
      </section>

      <section className="sec sec10 py-5 testimonials">
        <div className="container">
          <p className="text-center qoute pb-4">
            <img src={quote} alt="" />
          </p>
        </div>
        <div className="trustBox-widget py-4 py-lg-5 mb-5">
          <div className="container">
            <TrustpilotWidget />
          </div>
        </div>
        <div className="testimonials-products">
          <div className="container">
            <div className="row">
              <figure className="d-none d-md-block col-12 col-md-5">
                <p>
                  <img src={upsell} alt="" />
                </p>
              </figure>
              <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                <h3>{sec7Content}</h3>
                <figure className="d-md-none">
                  <img src={upsell} alt="" />
                </figure>
                <p className="btn-cont mt-5 text-center text-md-left">
                  <a
                    href={sec7Button1Url}
                    className="btn btn-dark  d-md-inline-block mb-3 mr-1"
                  >
                    {sec7Button1Text}
                  </a>
                  <a
                    href={sec7Button2Url}
                    className="btn btn-dark  d-md-inline-block mb-3 ml-sm-3"
                  >
                    {sec7Button2Text}
                  </a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

LandingPageWoolPops.defaultProps = {
  // Section 1 - Header
  sec1Button1Text: 'BUY',
  sec1Button1Url: '#',
  sec1Heading: (<h1><strong>WOOL</strong>POPS</h1>),
  sec1Content: 'LOREM IPSUM DOLOR SIT AMET',
  sec1Price: '$139',

  // Section 2
  sec2Button1Text: 'BUY',
  sec2Button1Url: '#',
  sec2Heading: (<h2>Made of <br/> <strong> 100% Wool</strong></h2>),
  sec2Content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut dolor tristique, dictum nunc vel, convallis orci. Integer tincidunt aliquam ante, nec finibus risus faucibus ac.',

  // Section 3
  sec3Heading: (<h2>THE PATENTED <br /> <strong> NATURAL <br /> RUBBER SOLE</strong></h2>),
  sec3Content: 'Sturdy, firm and natural. The deep profile and custom-fit workmanship guarantee the perfect grip and secure support. Your slippers stay flexible despite their robust quality – this feature rounds the shoe off perfectly! Ideal for preschool, a stroll along the terrace, school or the office.',
  sec3Button1Text: 'Learn More',
  sec3Button1Url: '#',
  sec3MobileImage: staticSec3MobileImage,
  sec3Image: staticSec3Image,

  // Section 4 - Carouse
  sec4Heading: (<h2>Really cool colors  <br /> <strong> back the 80's</strong></h2>),
  imageSec4DarkPink: staticImageSec4DarkPink,
  imageSec4DarkOrange: staticImageSec4DarkOrange,
  imageSec4DarkRed: staticImageSec4DarkRed,
  imageSec4DarkYellow: staticImageSec4DarkYellow,
  imageSec4DarkGreen: staticImageSec4DarkGreen,
  imageSec4DarkBlue: staticImageSec4DarkBlue,
  imageSec4LightPink: staticImageSec4LightPink,
  imageSec4LightOrange: staticImageSec4LightOrange,
  imageSec4LightRed: staticImageSec4LightRed,
  imageSec4LightYellow: staticImageSec4LightYellow,
  imageSec4LightGreen: staticImageSec4LightGreen,
  imageSec4LightBlue: staticImageSec4LightBlue,
  glowEffect1: staticGlowEffect1,
  glowEffect2: staticGlowEffect2,
  glowEffect3: staticGlowEffect3,
  glowEffect4: staticGlowEffect4,
  lightFabric: staticLightFabric,
  darkFabric: staticDarkFabric,
  circleSemi1: staticCircleSemi1,
  circleSemi2: staticCircleSemi2,

  // Section 5
  sec5Heading: (<h2><strong>100%</strong> <br /><strong>Sustainable </strong> <br /> since 1954</h2>),
  sec5Content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut dolor tristique, dictum tincidunt aliquam nunc vel, convallis orci. Integer tincidunt aliquam ante, nec finibus risus faucibus ac.',
  sec5Button1Text: 'Learn More',
  sec5Button1Url: '#',
  sec5Usp1Content: (<span>Zero waste <br /> Policy</span>),
  sec5Usp2Content: (<span>100% <br /> Sustainable</span>),
  sec5Usp3Content: (<span>Made by <br /> Recycled water</span>),
  zeroWaste: staticZeroWaste,
  sustainable: staticSustainable,
  recycled: staticRecycled,
  sec5MobileImage: staticSec5MobileImage,
  sec5Image: staticSec5Image,

  // Section 6
  sec6Heading: (<h2><strong>MACHINE <br />WASHABLE</strong>  <br /> AND EASY TO <br /> CARE FOR</h2>),
  sec6Content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut dolor tristique, dictum nunc vel, convallis orci. Integer tincidunt aliquam ante, nec finibus risus faucibus ac.',
  shoeLayer1: staticShoeLayer1,
  shoeLayer2: staticShoeLayer2,
  shoeLayer1Effect: staticShoeLayer1Effect,
  shoeLayer2Effect: staticShoeLayer2Effect,
  sec7Content: (
    <>
      <strong>These Clients bought this shoe,</strong>{' '}
      <br className="d-none d-md-block" /> Maybe try this one too
    </>
  ),
  sec7Button1Text: 'Women',
  sec7Button1Url: '#',
  sec7Button2Text: 'Men',
  sec7Button2Url: '#',
}

export default LandingPageWoolPops;